/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector, getUserSelector } from '../../user/selectors'
import { CrewService } from '../services/crew.service'
import { setCrewListData, setName } from '../store/crew.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ICrewList, ICrewListMember } from '../../pcr/models/crewList.V1'
import { IOptions } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setClientDataError } from '../../clientData/store/clientData.actions'
import i18n from '../../../i18n'

export function* getCrewList() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const crewService = new CrewService(serviceId)
    const { userId } = yield select(getUserSelector)

    const crewListResponse: ICrewList = yield call([crewService, crewService.getCrewList])
    const clinicalCrewListResponse: ICrewList = yield call([crewService, crewService.getClinicalCrewList])

    const crewList = crewListResponse && crewListResponse.entity ? crewListResponse.entity : []
    const clinicalCrewList =
      clinicalCrewListResponse && clinicalCrewListResponse.entity ? clinicalCrewListResponse.entity : []
    const loggedInUser = crewList?.find((member) => +member.userId === +userId)

    if (!loggedInUser) {
      yield put(setClientDataError(i18n.t('shift.loggedInUserNotFoundErr')))
      return
    }

    if (clinicalCrewList.length > 0) {
      if (!clinicalCrewList.some((member) => +member.userId === +userId)) {
        clinicalCrewList?.push(loggedInUser)
      }
    } else {
      clinicalCrewList?.push(loggedInUser)
    }

    clinicalCrewList?.forEach((crewMember: ICrewListMember) => {
      if (crewMember.firstName === null || crewMember.lastName === null) {
        if (crewMember.firstName === null) {
          crewMember.firstName = 'Unknown'
        }
        if (crewMember.lastName === null) {
          crewMember.lastName = 'Unknown'
        }
        crewMember.firstName += ` (${crewMember.userId})`
      }
    })
    clinicalCrewList?.sort((e1: ICrewListMember, e2: ICrewListMember) => e1.lastName!.localeCompare(e2.lastName!))
    const options: IOptions = clinicalCrewList?.map((crewMember: ICrewListMember) => {
      return {
        id: +crewMember.userId,
        name: `${crewMember.lastName}, ${crewMember.firstName}`,
      }
    })
    yield put(setCrewListData(options))
    yield put(setName())
  } catch (e) {
    yield put(throwPcrException(`getCrewList() error: ${e}`))
  }
}

export function* getCrewListSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCrewList)
}
